export default "https://cdn-static.gokick.com/assets/a922e5568f1cf4039f8565ae5776ec3d05b76040/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";